import React from 'react';
import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { AppLayout } from '../layouts/AppLayout';
import { LandingPage } from '../pages/LandingPage';
import { GalleryRouter } from '../pages/GalleryRouter';
import { AboutPage } from '../pages/AboutPage';
import { CvPage } from '../pages/CvPage';
import { ContactPage } from '../pages/ContactPage';

// Routing (architecture §3): landing at `/` (standalone chrome); everything else under the
// AppLayout. About/CV/Contact are explicit; the splat hands arbitrary-depth gallery paths
// to GalleryRouter, which renders a section, a viewing room, or 404.
export const routes: RouteObject[] = [
    { path: '/', element: <LandingPage /> },
    {
        element: <AppLayout />,
        children: [
            { path: 'about', element: <AboutPage /> },
            { path: 'cv', element: <CvPage /> },
            { path: 'contact', element: <ContactPage /> },
            { path: '*', element: <GalleryRouter /> },
        ],
    },
];

export const ApplicationRoutes = createBrowserRouter(routes);
